export const state = {
  data: {
    aAndB: {
      intraoccupational: {
        title: 'Intralaboral A y B',
        subTitle: {
          a: '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL A NIVEL INTRALABORAL',
          b: '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL B NIVEL INTRALABORAL',
				},
        info: `
                <p>
                Según la batería de instrumentos para la evaluación de factores de
                riesgo psicosocial, del Ministerio de Protección Social (2010),
                realizado por la Universidad Javeriana. “Las condiciones intralaborales,
                son entendidas como aquellas características del trabajo y de su
                organización que influyen en la salud y bienestar del individuo.”
                </p>
                <p>
                La información recolectada ha sido analizada según las condiciones
                psicométricas establecidas en la batería utilizada. Su presentación es
                realizada por medio de tablas y gráficos; los cuales se encuentran
                debidamente agrupados por dominios y dimensiones, de acuerdo a la
                estructura establecida por el instrumento. Los datos son presentados
                según la escala de valoración establecida para evaluar el riesgo
                psicosocial intralaboral: riesgo muy alto, riesgo alto, riesgo medio,
                riesgo bajo y sin riesgo.
                </p>
                <p>
                Se sugiere tener presente la interpretación genérica de los niveles de
                riesgo psicosocial intralaboral, la cual se cita a continuación:
                </p>
            `,
      },
      outsidework: {
        title: 'Extralaboral A y B',
        subTitle:{
					a: '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL A NIVEL EXTRALABORAL',
          b: '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL B NIVEL EXTRALABORAL',
				},
        info: `
            <p>            
            Según la batería de instrumentos para la evaluación de factores de riesgo psicosocial, 
            del Ministerio de Protección Social (2010), realizado por la Universidad Javeriana. 
            “Las condiciones intralaborales, son entendidas como aquellas características del trabajo y de su organización que influyen en la salud y bienestar del individuo.”
            </p>
            <p>
            La información recolectada ha sido analizada según las condiciones psicométricas establecidas en la batería utilizada. Su presentación es realizada por medio de tablas y gráficos; los cuales se encuentran debidamente agrupados por dimensiones, de acuerdo a la estructura establecida por el instrumento. Los datos son presentados según la escala de valoración establecida para evaluar el riesgo psicosocial intralaboral: riesgo muy alto, riesgo alto, riesgo medio, riesgo bajo y sin riesgo.
            </p>
            <p>
            Se sugiere tener presente la interpretación genérica de los niveles de riesgo psicosocial intralaboral, la cual se cita a continuación:
            </p>
            `,
      },
      stress: {
        title: 'Estrés A y B',
        subTitle:{
          a: '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL A NIVEL DEL ESTRÉS',
          b: '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL B NIVEL DEL ESTRÉS',
				},
        info: `
            <p>            
            Según la batería de instrumentos para la evaluación de factores de riesgo psicosocial, del Ministerio de Protección Social (2010), realizado por la Universidad Javeriana. El objetivo del cuestionario para la evaluación del estrés, está orientado a: “identificar los síntomas fisiológicos, de comportamiento social y laboral, intelectuales y psicoemocionales del estrés.”
            </p>
            <p>
            La información recolectada ha sido analizada según las condiciones psicométricas establecidas en la batería utilizada. Los datos son presentados según la escala de valoración establecida para evaluar los niveles de estrés: muy bajo, bajo, medio, alto y muy alto.
            </p>
            <p>
            Se sugiere tener presente la interpretación genérica de los niveles de estrés, la cual se cita a continuación:
            </p>
            `,
      },
    },
    aPlusB: {
      intraoccupational: {
        title: 'Intralaboral A + B',
        subTitle:
          '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL A + B NIVEL INTRALABORAL',
        info: `
                <p>
                Según la batería de instrumentos para la evaluación de factores de
                riesgo psicosocial, del Ministerio de Protección Social (2010),
                realizado por la Universidad Javeriana. “Las condiciones intralaborales,
                son entendidas como aquellas características del trabajo y de su
                organización que influyen en la salud y bienestar del individuo.”
                </p>
                <p>
                La información recolectada ha sido analizada según las condiciones
                psicométricas establecidas en la batería utilizada. Su presentación es
                realizada por medio de tablas y gráficos; los cuales se encuentran
                debidamente agrupados por dominios y dimensiones, de acuerdo a la
                estructura establecida por el instrumento. Los datos son presentados
                según la escala de valoración establecida para evaluar el riesgo
                psicosocial intralaboral: riesgo muy alto, riesgo alto, riesgo medio,
                riesgo bajo y sin riesgo.
                </p>
                <p>
                Se sugiere tener presente la interpretación genérica de los niveles de
                riesgo psicosocial intralaboral, la cual se cita a continuación:
                </p>
            `,
      },
      outsidework: {
        title: 'Extralaboral A + B',
        subTitle:
          '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL A + B NIVEL EXTRALABORAL',
        info: `
            <p>            
            Según la batería de instrumentos para la evaluación de factores de riesgo psicosocial, 
            del Ministerio de Protección Social (2010), realizado por la Universidad Javeriana. 
            “Las condiciones intralaborales, son entendidas como aquellas características del trabajo y de su organización que influyen en la salud y bienestar del individuo.”
            </p>
            <p>
            La información recolectada ha sido analizada según las condiciones psicométricas establecidas en la batería utilizada. Su presentación es realizada por medio de tablas y gráficos; los cuales se encuentran debidamente agrupados por dimensiones, de acuerdo a la estructura establecida por el instrumento. Los datos son presentados según la escala de valoración establecida para evaluar el riesgo psicosocial intralaboral: riesgo muy alto, riesgo alto, riesgo medio, riesgo bajo y sin riesgo.
            </p>
            <p>
            Se sugiere tener presente la interpretación genérica de los niveles de riesgo psicosocial intralaboral, la cual se cita a continuación:
            </p>
            `,
      },
      stress: {
        title: 'Estrés A + B',
        subTitle:
          '4.2 RESULTADOS DE LOS FACTORES DE RIESGO PSICOSOCIAL A NIVEL DEL ESTRÉS',
        info: `
            <p>            
            Según la batería de instrumentos para la evaluación de factores de riesgo psicosocial, del Ministerio de Protección Social (2010), realizado por la Universidad Javeriana. El objetivo del cuestionario para la evaluación del estrés, está orientado a: “identificar los síntomas fisiológicos, de comportamiento social y laboral, intelectuales y psicoemocionales del estrés.”
            </p>
            <p>
            La información recolectada ha sido analizada según las condiciones psicométricas establecidas en la batería utilizada. Los datos son presentados según la escala de valoración establecida para evaluar los niveles de estrés: muy bajo, bajo, medio, alto y muy alto.
            </p>
            <p>
            Se sugiere tener presente la interpretación genérica de los niveles de estrés, la cual se cita a continuación:
            </p>
            `,
      },
    },
  },
}
export const mutations = {}

export const getters = {
  data: (state) => state.data,
}

export const actions = {}
